/**
 * Strips undefined, null, and empty string values from a params object.
 * Used to clean query parameters before sending to the API.
 */
export const createCleanParams = <T extends Record<string, unknown>>(
    paramsObj: T
): Partial<T> => {
    const validParams: Partial<T> = {}
    for (const [key, value] of Object.entries(paramsObj)) {
        if (value === undefined || value === null || value === '') {
            continue
        }
        // Skip empty arrays
        if (Array.isArray(value) && value.length === 0) {
            continue
        }
        ;(validParams as Record<string, unknown>)[key] = value
    }
    return validParams
}
